module.exports = __webpack_public_path__ + "static/media/my_booking_selected.32791c19.svg";